import Icon from '../components/Icon';

export const svgContents = (
  <>
    <path
      fillRule="evenodd"
      d="M1.47 1.47a.75.75 0 0 1 1.06 0l4.296 4.295a.75.75 0 0 1 .387.387l2.59 2.59a.8.8 0 0 1 .152.152L22.53 21.47a.75.75 0 1 1-1.06 1.06l-4.08-4.08c-1.482.775-3.272 1.3-5.39 1.3-7.232 0-10.522-6.075-11.085-7.23a1.18 1.18 0 0 1 0-1.04c.357-.733 1.72-3.264 4.377-5.127L1.47 2.53a.75.75 0 0 1 0-1.06M2.332 12c.414-.81 1.695-3.01 4.039-4.568l1.96 1.96a4.5 4.5 0 0 0 6.275 6.275l1.664 1.664c-1.198.555-2.613.919-4.27.919-6.054 0-8.985-4.912-9.668-6.25M9 12c0-.557.151-1.077.415-1.524l4.109 4.109A3 3 0 0 1 9 12"
      clipRule="evenodd"
    />
    <path d="M11.25 8.25A.75.75 0 0 1 12 7.5a4.5 4.5 0 0 1 4.5 4.5.75.75 0 0 1-1.5 0 3 3 0 0 0-3-3 .75.75 0 0 1-.75-.75" />
    <path d="M12 4.25q-.7 0-1.354.074a.75.75 0 0 0 .165 1.49A11 11 0 0 1 12 5.75c6.054 0 8.985 4.912 9.668 6.25-.245.48-.805 1.467-1.723 2.518a.75.75 0 1 0 1.13.987 14.1 14.1 0 0 0 2.008-2.982c.16-.327.165-.71.002-1.043-.563-1.155-3.853-7.23-11.085-7.23" />
  </>
);

const Hide = Icon('hide', svgContents);

export default Hide;
